// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ttd-container {
    --primary-50: #e9f2ff;
    --primary-300: #7fb7ff;
    --primary-500: #0077d6;
    --primary-700: #035aa6;
    --muted: #6b7280;

    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
    line-height: 1.65;
    margin: 24px;
    padding: 32px;
    background: linear-gradient(180deg, var(--primary-50), #f6fbff);
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(2,48,84,0.06);
    color: #042a48;
}

.ttd-title-headline {
    font-size: 24px;
    font-weight: 800;
    color: var(--primary-700);
    margin-bottom: 10px;
}

.ttd-sub-title-headline {
    font-size: 18px;
    font-weight: 700;
    margin-left: 18px;
    color: #07355f;
}

.ttd-text {
    margin-left: 28px;
    font-size: 16px;
    color: var(--muted);
}

.ttd-img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 18px auto;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(2,48,84,0.04);
}

.ttd-sub-text {
    margin-left: 36px;
    font-size: 15px;
    color: var(--muted);
}

/* Bullet Styles */
.ttd-list {
    list-style-type: none;
    padding-left: 56px;
}

.ttd-outline-bullet {
    position: relative;
    padding-left: 44px;
    margin-bottom: 8px;
}

.ttd-outline-bullet::before {
    content: "○";
    position: absolute;
    left: 0;
    color: var(--primary-500);
    font-size: 14px;
}

.ttd-square-list {
    list-style-type: none;
    padding-left: 40px;
}

.ttd-square-bullet {
    position: relative;
    padding-left: 25px;
    margin-bottom: 5px;
}

.ttd-square-bullet::before {
    content: "■";
    position: absolute;
    left: 0;
    color: var(--primary-500);
    font-size: 14px;
}

@media (max-width: 900px) {
    .ttd-container { padding: 18px; margin: 12px; }
    .ttd-sub-title-headline, .ttd-text, .ttd-sub-text { margin-left: 12px; }
    .ttd-list { padding-left: 20px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pmp/ttd/ttd.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;;IAEhB,2FAA2F;IAC3F,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,+DAA+D;IAC/D,mBAAmB;IACnB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB,aAAa,EAAE,YAAY,EAAE;IAC9C,oDAAoD,iBAAiB,EAAE;IACvE,YAAY,kBAAkB,EAAE;AACpC","sourcesContent":[".ttd-container {\n    --primary-50: #e9f2ff;\n    --primary-300: #7fb7ff;\n    --primary-500: #0077d6;\n    --primary-700: #035aa6;\n    --muted: #6b7280;\n\n    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\n    line-height: 1.65;\n    margin: 24px;\n    padding: 32px;\n    background: linear-gradient(180deg, var(--primary-50), #f6fbff);\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(2,48,84,0.06);\n    color: #042a48;\n}\n\n.ttd-title-headline {\n    font-size: 24px;\n    font-weight: 800;\n    color: var(--primary-700);\n    margin-bottom: 10px;\n}\n\n.ttd-sub-title-headline {\n    font-size: 18px;\n    font-weight: 700;\n    margin-left: 18px;\n    color: #07355f;\n}\n\n.ttd-text {\n    margin-left: 28px;\n    font-size: 16px;\n    color: var(--muted);\n}\n\n.ttd-img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n    margin: 18px auto;\n    border-radius: 8px;\n    box-shadow: 0 8px 20px rgba(2,48,84,0.04);\n}\n\n.ttd-sub-text {\n    margin-left: 36px;\n    font-size: 15px;\n    color: var(--muted);\n}\n\n/* Bullet Styles */\n.ttd-list {\n    list-style-type: none;\n    padding-left: 56px;\n}\n\n.ttd-outline-bullet {\n    position: relative;\n    padding-left: 44px;\n    margin-bottom: 8px;\n}\n\n.ttd-outline-bullet::before {\n    content: \"○\";\n    position: absolute;\n    left: 0;\n    color: var(--primary-500);\n    font-size: 14px;\n}\n\n.ttd-square-list {\n    list-style-type: none;\n    padding-left: 40px;\n}\n\n.ttd-square-bullet {\n    position: relative;\n    padding-left: 25px;\n    margin-bottom: 5px;\n}\n\n.ttd-square-bullet::before {\n    content: \"■\";\n    position: absolute;\n    left: 0;\n    color: var(--primary-500);\n    font-size: 14px;\n}\n\n@media (max-width: 900px) {\n    .ttd-container { padding: 18px; margin: 12px; }\n    .ttd-sub-title-headline, .ttd-text, .ttd-sub-text { margin-left: 12px; }\n    .ttd-list { padding-left: 20px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
